import '@hitmakers/phaser';
import BootScene from '../scenes/bootScene';
import RoadScene from '../scenes/roadScene';
import BattleScene from '../scenes/battleScene';
import MusicScene from '../scenes/musicScene';
import GrayScalePipeline from '../game/gray-scale';
import CharSelectionScene from "@/scenes/charSelectionScene";
import CreatureScene from "@/scenes/creatureScene";
import PreloadScene from "@/scenes/preloadScene";
import ArenaScene from "@/scenes/arenaScene";
import ClanScene from "@/scenes/clanScene";
import CU from "../utils/c-u";
import LoadScene from "@/scenes/loadScene";
import BootFixScene from "@/scenes/bootFixScene";
import BattleLoadScene from "@/scenes/battleLoadScene";
import CreatureLoadScene from "@/scenes/creatureLoadScene";
import ClanLoadScene from "@/scenes/clanLoadScene";
import CDNUtils from "@/utils/cdn-utils";
import {IntegrationUtils} from "@/utils/integration-utils";

function launch(containerId: string, headerId: string, footerId: string) {
  CU.resizeCanvas(containerId);

  let loaderConf: any = {
    maxParallelDownloads: 36,
  }

  if (CDNUtils.usingCDN()) {
    loaderConf = {
      maxParallelDownloads: 36,
      baseURL: CDNUtils.getStaticUrl(false)
    }
  }

  const config = {
    type: IntegrationUtils.isBeelineUser() ? Phaser.CANVAS : Phaser.AUTO,
    width: CU.CANVAS_WIDTH,
    height: CU.CANVAS_HEIGHT,
    parent: containerId,
    scale: {
      mode: Phaser.Scale.NONE,
      autoCenter: Phaser.Scale.CENTER_HORIZONTALLY
    },
    dom: {
      createContainer: true,
    },
    render: {
      clearBeforeRender: false,
      batchSize: 512,
      antialiasGL: false
    },
    enableDebug: false,
    pipeline: { 'Gray': GrayScalePipeline },
    scene: [PreloadScene, BootScene, RoadScene, BattleScene, CharSelectionScene, CreatureScene, CreatureLoadScene,
      ArenaScene, ClanScene, LoadScene, MusicScene, BootFixScene, BattleLoadScene, ClanLoadScene ],

    loader: loaderConf,
  };

  // @ts-ignore
  return new Phaser.Game(config);
}

export default launch;
export { launch };
